import Admin__MessageExceptionTemplatesController from './message_exception_templates.js'

Skylark.App.Controllers.register({
  Admin__MessageExceptionTemplatesController
})

export default Admin__MessageExceptionTemplatesController
